import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

const Style = styled.div<{ backgroundImage: string }>`
  background-image: url(${(props) => props.backgroundImage || null});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  height: 100%;
  width: 100%;

  div {
    background: white;
    border: 1px solid ${COLORS.lightGray};
    left: 50%;
    position: fixed;
    padding: 40px 25px;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 15;

    > h2 {
      color: ${COLORS.orange};
      font-weight: 300;
      margin-bottom: 15px;
    }

    > h3 {
      font-weight: 300;
      font-size: 1.3rem;
    }
  }
`;

export const FailurePageWrapper = styled(Style)`
  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
`;
